import { ViewObjectSettings } from "../view-object-settings";

export class GridSettings extends ViewObjectSettings {
  constructor(settings) {
    super(settings);
    this.rowsSpace = settings.rowsSpace?.copy(); // type: CalculatedDimension
    this.rows = [];
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      let rowSettings = settings.rows[rowIndex];
      let rowInfo = {
        height: rowSettings.height?.copy(), // type: CalculatedDimension
        columnsSpace: rowSettings.columnsSpace?.copy(), // type: CalculatedDimension
        columns: []
      };
      for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
        let columnSettings = rowSettings.columns[columnIndex];
        rowInfo.columns.push({
          width: columnSettings.width?.copy(),
          item: columnSettings.item?.copy() // type: ViewObjectSettings
        });
      }
      this.rows.push(rowInfo);
    }
  }

  copy() {
    return new GridSettings(this);
  }
}
